import Cookies from "universal-cookie";
import {
  STATE_CULTURE,
  STATE_CURRENCY,
  STATE_POS_ID,
  STATE_SALE_ID,
} from "../Actions/cookiesActions";

const cookies = new Cookies(null, { path: "/" });

const map = (q) => {
  switch (q) {
    case "cul":
      return STATE_CULTURE;
    case "cur":
      return STATE_CURRENCY;
    case "sale":
      return STATE_SALE_ID;
    case "pos":
      return STATE_POS_ID;
    default:
      throw new Error("Unknown parameter " + q);
  }
};

//Get values from querystring or cookie
const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  //Check cookie
  const key = map(variable);
  const stored = cookies.get(key);
  return stored;
};

const posIdCookie = cookies.get("checkout-posId");

export default {
  culture: getQueryVariable("cul") || "sv-SE",
  currency: getQueryVariable("cur") || "SEK",
  saleId: getQueryVariable("sale"),
  posId: getQueryVariable("pos")
    ? Number(getQueryVariable("pos"))
    : Number(posIdCookie)
    ? Number(posIdCookie)
    : 1,
};
